import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h3 className="mt-5 text-danger text-center">Page not found</h3>
            <h5 className="text-danger text-center">404 error...</h5>
        </div>
    );
};

export default NotFound;